import { PaginationERP, TableERP } from "@finanedi.es/storybook"
import { MovimientoBancarioReadingDtoProps } from "api/DTOs/MovimientoBancarioReadingDto"
import { ESTADO_CONCILIACION } from "api/Types/EstadoConciliacion"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import React, { useState } from "react"
import { frontendCurrency } from "utils/formatCurrency"
import { DrawerMovimientosBancarios } from "../components/DrawerMovimientosBancarios"
import { FilterMenu } from "../components/FilterMenu"
import { CONCILIACION_MANUAL_COLUMNS } from "../constants/conciliacionManualTableColumns"
import { ColumnLeftProps } from "./ColumnLeft.interface"

const ColumnLeft: React.FC<ColumnLeftProps> = ({
  selectedNewLeft,
  setSelectedNewLeft,
  handleResetPagination,
  isLoading,
  items,
  OptionsButton,
  pagination,
  dtRef,
  upperSectionForzada,
  setPagination,
  setServiceQuery,
  setSortingCriteria,
  sortingCriteria,
  t,
  totalCount,
  datePadre,
  refrescar,
}) => {
  const [isDrawerExpanded, setIsDrawerExpanded] = useState(false)
  const toggleLowerSection = () => {
    setIsDrawerExpanded(!isDrawerExpanded)
  }

  const isConciliada =
    selectedNewLeft?.[0]?.estadoConciliacion === ESTADO_CONCILIACION.CONCILIADO

  const unSelectedRow = (rowData: MovimientoBancarioReadingDtoProps) => {
    const selected = [...selectedNewLeft]
    const index = selected.findIndex(
      (item) => item.idExterno === rowData.idExterno
    )
    if (index !== -1) selected.splice(index, 1)
    setSelectedNewLeft(selected)
    selected.length < 1 && setIsDrawerExpanded(false)
  }

  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | 0 | -1 | null | undefined>(0)
  const onSort = ({
    sortField,
    sortOrder,
  }: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => {
    setSortingCriteria({
      property: sortField ?? undefined,
      sort: sortOrder === 1 ? "ASC" : sortOrder === -1 ? "DESC" : undefined,
    })
    setSortField(sortField)
    setSortOrder(sortOrder)
    handleResetPagination()
  }

  return (
    <div className='tw-flex tw-max-h-full tw-h-full tw-flex-col tw-justify-between tw-bg-white tw-border-r'>
      <section className='tw-relative tw-flex tw-flex-1 tw-flex-col tw-overflow-hidden'>
        <div className='tw-flex-1 tw-overflow-auto tw-bg-gray-100 tw-transition-opacity tw-duration-100'>
          <div className='tw-h-full tw-flex-1 tw-items-center tw-overflow-hidden tw-transition-all tw-duration-100 tw-ease-in-out'>
            <section
              className='tw-flex tw-flex-col tw-text-nowrap tw-bg-background tw-h-full'
              id='section-documentos-conciliables'
            >
              <FilterMenu
                datePadre={datePadre}
                serviceQuery={setServiceQuery}
                sortingCriteria={sortingCriteria}
                maxResultCount={pagination.itemsPerPage}
                skipCount={pagination.skipCount}
                resetPagination={handleResetPagination}
                refrescar={refrescar}
              />

              <div className='tw-flex-grow tw-relative tw-h-[calc(100%-80px)]'>
                <div className='tw-flex tw-flex-col tw-h-[calc(100%-64px)] tw-relative'>
                  <div className='tw-h-[calc(100%-60px)] tw-min-h-0'>
                    <TableERP
                      refTable={dtRef}
                      columns={CONCILIACION_MANUAL_COLUMNS(t, OptionsButton)}
                      className='tw-h-full tw-max-w-full'
                      columnResizeMode='expand'
                      sortField={sortField}
                      sortOrder={sortOrder}
                      onSort={onSort}
                      removableSort
                      value={items}
                      showGridlines
                      dataKey='idExterno'
                      lazy
                      scrollable
                      selection={selectedNewLeft}
                      selectionMode='checkbox'
                      size='small'
                      isDataSelectable={(event) =>
                        event.data.estadoConciliacion !==
                        ESTADO_CONCILIACION.CONCILIADO
                      }
                      selectionColumnMode='multiple'
                      onRowClick={({ data }) => {
                        const isConciliado =
                          data.estadoConciliacion ===
                          ESTADO_CONCILIACION.CONCILIADO
                        const index = selectedNewLeft.findIndex(
                          (item) => item.idExterno === data.idExterno
                        )
                        if (isConciliado && index === -1) {
                          upperSectionForzada()
                          setSelectedNewLeft([data])
                          return
                        }
                        if (isConciliado && index !== -1) {
                          setSelectedNewLeft([])
                          return
                        }
                        const updated = [...selectedNewLeft]
                        if (index === -1) {
                          updated.push(data)
                        } else {
                          updated.splice(index, 1)
                        }
                        setSelectedNewLeft(
                          updated.filter(
                            (item) =>
                              item.estadoConciliacion !==
                              ESTADO_CONCILIACION.CONCILIADO
                          )
                        )
                      }}
                      onSelectionChange={({
                        value,
                      }: {
                        value: MovimientoBancarioReadingDtoProps[]
                        type?:
                          | "multiple"
                          | "all"
                          | "checkbox"
                          | "row"
                          | undefined
                      }) => {
                        setSelectedNewLeft(
                          value.filter(
                            (item) =>
                              item.estadoConciliacion !==
                              ESTADO_CONCILIACION.CONCILIADO
                          )
                        )
                      }}
                      loading={isLoading}
                      emptyMessage={`${t("primeReact.table.emptyMessage")}`}
                    />
                  </div>
                  <PaginationERP
                    className={PAGINATION_STYLES}
                    totalRecords={totalCount}
                    first={pagination.skipCount}
                    rows={pagination.itemsPerPage}
                    resetScroll={() =>
                      dtRef.current && dtRef.current?.resetScroll()
                    }
                    setPagination={setPagination}
                    optionDropdown={[10, 20, 50, 100]}
                    texts={{
                      textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
                      textCurrentPageReport: `${t("pagination.from")}`,
                    }}
                  />
                </div>
                <DrawerMovimientosBancarios
                  isLowerSectionExpanded={isDrawerExpanded}
                  selectedDocuments={selectedNewLeft}
                  toggleLowerSection={toggleLowerSection}
                  unSelectedRow={unSelectedRow}
                  t={t}
                />
              </div>
            </section>
          </div>
        </div>
      </section>
      <div className='tw-flex !tw-h-20 tw-full tw-flex-row tw-items-center tw-justify-between tw-bg-white tw-p-1 tw-border-t'>
        {!isConciliada && (
          <span className='tw-flex tw-gap-2 tw-pl-6 tw-font-medium'>
            {t("bancos.conciliacion.leftColumn.selectedAmount", {
              amount: frontendCurrency(
                selectedNewLeft?.reduce(
                  (total, movimiento) =>
                    total + Number(movimiento.importe || 0),
                  0
                ) || 0
              ),
            })}
          </span>
        )}
      </div>
    </div>
  )
}

export default ColumnLeft
